import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import VideosPage from "../pages/videos/page";
import NewsDetailPage from "../pages/news/page";
import VideoDetailPage from "../pages/video/page";
import SpecialDetailPage from "../pages/special/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "videos", element: <VideosPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "video/:id", element: <VideoDetailPage /> },
      { path: "special/:id", element: <SpecialDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;